(function ($) {
    $(".toggle-dropdown").click(function (e) {
        $(this).next().toggle();
    });
    
    $(".toggle-dropdown-info").click(function (e) {
        e.preventDefault();
        $(".appointment-info").toggle();
    });

    $(".close-note").click(function (e) {
        $(this).parent().parent().toggle();
    });

    $(".collapse-title").click(function (e) {
        $(this).find('.glyphicon').toggleClass('glyphicon-menu-up').toggleClass('glyphicon-menu-down');
    });
    
    $("#showTextForPatient .close-info").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#showTextForPatient, .parentText").toggle();
    });
})(jQuery);